<mat-expansion-panel
  [hideToggle]="hideToggle"
  [expanded]="expanded"
  [disabled]="disabled"
  (opened)="onOpened()"
  class="expansion-panel"
>
  <mat-expansion-panel-header class="expansion-panel-header">
    <mat-panel-title class="expansion-panel-header-title">{{
      title
    }}</mat-panel-title>
    <mat-panel-description
      class="expansion-panel-header-description"
      [ngClass]="descriptionClasses"
      >{{ description }}</mat-panel-description
    >
  </mat-expansion-panel-header>
  <ng-content></ng-content>
</mat-expansion-panel>
